import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-part6',
  templateUrl: './part6.component.html',
  styleUrls: ['./part6.component.scss']
})
export class Part6Component implements OnInit {
  readonly baseURL = './assets/images/part6/'
  readonly baseElementURL = './assets/images/element/';
  readonly BoxList = [[
    {
      text: `שידור חי בדיליי קצר ויציב <br/>של עד 2-3 שניות`
      , imgUrl: 'clock.png'
      , borderRadius: '0 4vw 0 0'
    }
    , {
      text: `אולפן מעוצב ומקצועי<br/>והנחיה סוחפת במיוחד`
      , imgUrl: 'microphone.png'
      , borderRadius: '0 0 0 0'
    }
    , {
      text: `שילוב עם זום,<br/>לאווירה קבוצתית`
      , imgUrl: 'zoom.png'
      , borderRadius: '0 0 0 0'
    }
    , {
      text: `מס’ שחקנים גדול<br/>ללא הגבלת כמות`
      , imgUrl: 'screen.png'
      , borderRadius: '4vw 0 0 0'
    }
  ],
  [
    {
      text: `שם אישי לכל שחקן<br/>או זיהוי לפי מס’ טלפון`
      , imgUrl: 'tag.png'
      , borderRadius: '0 0 4vw 0'
    }
    , {
      text: `חלוקה לקבוצות ותתי קבוצות<br/>היוצרות תחרות וענין `
      , imgUrl: 'men.png'
      , borderRadius: '0 0 0 0'
    }
    , {
      text: `הצבעה מתוך האתר<br/>וצבירת נקודות אישית`
      , imgUrl: 'score.PNG'
      , borderRadius: '0 0 0 0'
    }
    , {
      text: `ד”שים והודעות תוך כדי שידור<br/>בשליחה לווצאפ או למייל`
      , imgUrl: 'regards.png'
      , borderRadius: '0 0 0 4vw'
    }
  ]]
  constructor() { }

  ngOnInit(): void {
  }

}
